/**
 * The incoming-call notification card's web twin.
 *
 * The native file draws and dismisses a notifee notification and keeps a
 * declines-pressed-while-dead queue in storage. None of those states exist
 * in a browser tab: a call that arrives while the tab is open is presented
 * by `IncomingCallOverlay` (plain React, shared code), and a tab that is
 * closed cannot ring at all - see `push.web.ts`.
 *
 * So every function is the no-op its caller already tolerates, with the
 * same signatures, and the action ids keep their native values so a payload
 * that ever crosses the boundary means the same thing on both.
 */

export const VOICE_ACTION_ACCEPT = 'voice-accept';
export const VOICE_ACTION_DECLINE = 'voice-decline';

/** There is no notification card on the web, so none to dismiss. */
export const dismissIncomingCall = async (_callId?: string): Promise<void> => {};

/**
 * Nothing queues on the web: a decline can only be pressed on the in-app
 * overlay, which is only up while the app is alive and able to send it.
 */
export const queueDecline = async (_callId: string): Promise<void> => {};

/* The push payload types are platform-blind data shapes; the native file
   stays their single source of truth. Type-only, so nothing of the notifee
   module behind it reaches this bundle. */
export type { VoiceIncomingPush, VoicePushEvent } from './incoming-call';
